import jsStorage from "js-storage";

export const storage = jsStorage.initNamespaceStorage('note-lawn-app').localStorage;